import {
  Shoes,
  BlackDumbell,
  DistanceWalked,
  Fire,
  MuscleMass,
  FatFreeWeight,
  BloodPressure,
  HeartRate,
  BodyFatPercentage,
  BMI,
  Weight,
  SleepDuration,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";

const formatValue = (value, locale) => {
  if (value === null || value === undefined) return "0";

  const stringValue = value.toString();

  if (locale === "nl") {
    return stringValue.replace(/\./g, ",");
  }

  return stringValue;
};

export const getStatCards = (summary = {}, t , i18n) => {
  return [
    {
      label: t("Total Steps"),
      value: summary?.totalSteps ?? 0,
      color: "#FFF7F0",
      icon: <Shoes />,
    },
    {
      label: t("Active Time"),
      value: summary?.activeTime ?? "0m",
      color: "#F4F4F4",
      icon: <BlackDumbell />,
    },
    {
      label: t("Distance"),
      value: formatValue(summary?.distance, i18n.language) ?? "0 km",
      color: "#F4FFF0",
      icon: <DistanceWalked />,
    },
    {
      label: t("Calories Burnt"),
      value: summary?.caloriesBurnt ?? 0,
      color: "#FFFAF0",
      icon: <Fire />,
    },
  ];
};



export const getDeviceCards = (summary = {}, t, i18n) => {
  return [
    {
      label: t("Sleep duration"),
      value: summary?.sleep_minutes,
      color: "#F0FFFF",
      icon: <SleepDuration />,
    },
    {
      label: t("Weight"),
      value: formatValue(summary?.weight, i18n.language),
      color: "#FFF0FB",
      icon: <Weight />,
    },
    {
      label: t("Body Fat %"),
       value: formatValue(summary?.body_fat_percentage, i18n.language),
      color: "#FDFFF0",
      icon: <BodyFatPercentage />,
    },
    {
      label: t("Muscle Mass"),
      value: formatValue(summary?.muscle_mass_kg, i18n.language),
      color: "#F0F5FF",
      icon: <MuscleMass />,
    },
    {
      label: t("Fat-Free Weight"),
      value: formatValue(summary?.fat_free_mass_kg, i18n.language),
      color: "#FEF0FF",
      icon: <FatFreeWeight />,
    },
    {
      label: t("BMI"),
      value: formatValue(summary?.bmi, i18n.language),
      color: "#F0FFF4",
      icon: <BMI />,
    },
    {
      label: t("Heart Rate"),
      value: formatValue(summary?.heart_rate, i18n.language),
      color: "#FFF6F0",
      icon: <HeartRate />,
    },
    {
      label: t("Blood Pressure"),
      value: summary?.blood_pressure,
      color: "#FFF0F0",
      icon: <BloodPressure />,
    },
  ];
};
